import React,{useState} from 'react'
// import Footer from './Footer';
import { FaArrowRight } from "react-icons/fa";

const WebsiteDevelopment = () => {
  const [formData, setFormData] = useState({
      name: '',
      email: '',
      message: ''
    });
  
    const [status, setStatus] = useState('');
  
    const handleChange = (e) => {
      setFormData({
        ...formData,
        [e.target.name]: e.target.value
      });
    };
  
    const handleSubmit = async (e) => {
      e.preventDefault();
  
      const response = await fetch('https://formspree.io/f/xvgopggk', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      });
  
      if (response.ok) {
        setFormData({ name: '', email: '', message: '' });
        setStatus('Message sent successfully!');
      } else {
        setStatus('Message failed to send. Please try again.');
      }
    };
  return (
    
    <div style={{backgroundColor:"#000435"}}>
      <div className='maincontainer-fifth' >
  
        <div className='leftonesixth' >
         <h1  className="gra">Android Development</h1>
        
         
          <ul className="space-y-2" style={{color:"white",marginTop:"5%"}}>
          <h5  > 
             <FaArrowRight className="audience">
             </FaArrowRight>Create A Unique Digital Experience
              </h5  > 
            
              <h5 > 
             <FaArrowRight className="audience">
             </FaArrowRight>Drive Higher Conversions
              </h5> 
             
              <h5 > 
             <FaArrowRight className="audience">
             </FaArrowRight> Attract Qualified Traffic
              </h5> 
             
          </ul>
        </div>
        <div className='rightone-third' >
        <div id="carouselExampleAutoplaying" className="carousel slide" data-bs-ride="carousel" data-bs-interval="2000" style={{width:"700px",height:"600px"}}>
  <div className="carousel-inner">
    <div className="carousel-item active">
      <img src="/images/Android-msg.jpg" className="d-block w-100" alt="..."/>
    </div>
    <div className="carousel-item">
      <img src="/images/Android-twich.jpg" className="d-block w-100" alt="..." />
    </div>
    <div className="carousel-item">
      <img src="/images/Android-last.jpg" className="d-block w-100" alt="..." />
    </div>
  </div>
  <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleAutoplaying" data-bs-slide="prev">
    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
    <span className="visually-hidden">Previous</span>
  </button>
  <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleAutoplaying" data-bs-slide="next">
    <span className="carousel-control-next-icon" aria-hidden="true"></span>
    <span className="visually-hidden">Next</span>
  </button>
</div>
      
        </div>
      </div> 
      
      <div className='maincontainer-fifth'>
        <div className='leftone-fifth'>

          <h1  className="cgd"> Custom Android Development Services</h1><br></br>
          <h4 className='bit' >
          Balaji IT  is a full-service agency comprised of leading web And App development from around the globe.
          </h4>
         
          <h3  className="adobe"style={{color:"#87CEEB"}}> Java And Ktlin</h3>
          
          <h3 className='adobe' style={{color:"#87CEEB"}}> Android Studio</h3>
          
          <h3 className='adobe' style={{color:"#87CEEB"}}> Jetpack Compose</h3>
         
        </div>
        <div className='rightone-forth' >
        
          <div className="contact-form-container">
            <h2 className='request' style={{color:"#87CEEB"}}> Request A Quote</h2>
            <h2 className='max'> Maximize Your Website’s Potential With Balaji_IT-Services  </h2>
            {/* <h2></h2> */}
      <form onSubmit={handleSubmit} className="contact-form">
        <label>Name</label>
        <input
          type="text"
          name="name"
          value={formData.name}
          onChange={handleChange}
          required
        />

        <label>Email</label>
        <input
          type="email"
          name="email"
          value={formData.email}
          onChange={handleChange}
          required
        />

        <label>Message</label>
        <textarea
          name="message"
          value={formData.message}
          onChange={handleChange}
          required
        ></textarea>

        <button type="submit">Send Message</button>

        {status && <p className="form-status">{status}</p>}
      </form>
     
    </div>

        </div>
      </div>
      <div className='final'>
      <img src="/images/All-final.png" alt="prop"></img>
    </div>
      {/* <Footer/> */}
    </div>
  )
}

export default WebsiteDevelopment;
